import { VirtualTableProps } from '@devexpress/dx-react-grid';
import styled from '@emotion/styled';

const TdStyled = styled.td`
  padding: 0;
  border: 0;
`;

const VirtualTableNoDataCell: VirtualTableProps['noDataCellComponent'] = ({ colSpan, rowSpan }) => (
  <TdStyled colSpan={colSpan} rowSpan={rowSpan} />
);

export default VirtualTableNoDataCell;
